export default {
  companyId: '',
  image: {},
  attachedFile: {},
  description: '',
  endDate: '',
  employeeIds: [],
  employees: [],
  link: '',
  name: '',
  position: '',
  startDate: ''
};
